import Moment from "moment";
let pathName = window.location.pathname;

export const getNoticeDetailUrl = function(id) {
    return pathName + `#/announce/${id}`;
};

export const mapNoticeItem = function(noticeItem) {
    return {
        id: noticeItem.id,
        name: noticeItem.title,
        isNew: Boolean(noticeItem.isNew),
        date: Moment(noticeItem.publishTime).format('YYYY-MM-DD')
    }
}

export const mapCourseItem = function(courseItem) {
    let coverPicSrc = null;
    if (courseItem.coverPic) {
        coverPicSrc = courseItem.coverPic.replace('http://', 'https://');
    }
    return {
        id: courseItem.id,
        title: courseItem.title,
        subTitle: courseItem.subTitle,
        src: coverPicSrc
    }
}
const phoneSplit = '-';
export const formatPhone = function(phoneStr) {
    if (phoneStr && typeof phoneStr === 'string') {
        let formatPhoneReg = /^(\d{3})(\d{4})(\d{4})$/
        let matches = formatPhoneReg.exec(phoneStr)
        if (matches && matches.length) {
            return matches.filter((mtach, index) => { return index > 0 }).join(phoneSplit);
        }
        return phoneStr;
    }
};


// WEBPACK FOOTER //
// ./src/utils/notices.js